module.exports = __webpack_public_path__ + "img/about1.1ae1efd3.png";